import React, { useState } from 'react'
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { useGetJudgeExhibitorByUserIdQuery } from '../../../hooks/scientific/useGetJudgeExhibitorByUserIdQuery';
import { useGetProjectsAssignedByIdJudge } from '../../../hooks/scientific/useGetJudgePhaseProjectsQuery';
import { ProjectType } from '../../../types/ScientificModule';
import { Pencil1Icon } from '@radix-ui/react-icons';
import { Lists } from '../../../components/common/Lists';
import TableComponent from '../../../components/common/Tables';
import { getProjectsDocuments } from '../../../services/scientific/projectDocument';
import { useAppDispatch } from '../../../hooks/hooks';
import { useNavigate } from 'react-router-dom';
import { setProjectsData } from '../../../redux/slices/scientific/projects';
import { routes } from '../../../routes';

const columnNamesMap: { [key: string]: string } = {
  description: 'Descrição',
  currentPhase: 'Fase actual',
  startdate: 'Data de Início',
};


export const ProjectsAssignedToJudge = () => {
  const userLogged = useSelector((state: RootState) => state.login.userData);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(1);
  const { data } = useGetJudgeExhibitorByUserIdQuery(userLogged.UserId, {
    enabled: !!userLogged.UserId
  })
  const idJudge = data?.idJudge;
  const { data: projects, status: projectStatus } = useGetProjectsAssignedByIdJudge({
    PageSize: 400, PageNumber: currentPage, IdJudge: idJudge
  }, {
    enabled: !!userLogged.UserId && !!idJudge
  })
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };
  const handleValidade = async (c: ProjectType) => {
    try {
      let { items } = await getProjectsDocuments({ PageSize: 400, PageNumber: 1, IdProject: c.id })
      items = items.filter(i => i.idProject === c.id);
      c.documents = items
      dispatch(setProjectsData(c));
      navigate(routes.validateProjectStep);
    }
    catch (ex) {
      console.error(ex);
    }

  };

  const options = projects?.items.map((c: ProjectType) => [
    {
      label: 'Validar',
      onClick: () => handleValidade(c),
      icon: <Pencil1Icon />
    }
  ]) || [];

  return (
    <>
      <Lists
        status={projectStatus}
        TableComponent={() =>
          <TableComponent
            columns={Object.keys(columnNamesMap)}
            items={projects?.items}
            options={options}
            columnNamesMap={columnNamesMap}
            totalPages={projects?.totalPages || 1}
            currentPage={currentPage}
            onPageChange={handlePageChange}
            emptyMessage="Ainda não existem projectos atribuídos para validação."
          />
        }
      />

    </>
  )
}
